import React, { Fragment, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import DefaultInput from "../../inputs/defaultInput";
import Loading from "../../skeleton/loading";
import DefaultTextarea from "../../inputs/defaultTextarea";
import DefaultButton from "../../buttons/defaultButton";
import {
  createDepartment,
  getDepartmentDetail,
  updateDepartment,
} from "../../../../services/workspace/department.service";
import { _updateDepartment } from "../../../../store/slices/baseSetup.slice";
import { _fetchDepartments } from "../../../../store/actions/configuration";
import { useDispatch } from "react-redux";
import DragAndDropFile from "../../inputs/simpleFileUploader";
import DefaultSearchSelectInput from "../../inputs/defaultSearchSelectInput";
import {
  createCategory,
  getCategoryDetail,
  getCategoryList,
  updateCategory,
} from "../../../../services/workspace/inventory.service";
import { convertToLabelValue } from "../../../../utils/common";

const validationSchema = Yup.object().shape({
  name: Yup.string().trim().required("Name is required"),
  parentCaterory: Yup.object().nullable(),
});

const ManageSalaryForm = ({ isModal = false, onClose = () => null, id }) => {
  const navigate = useNavigate();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [categorydata, setCategorydata] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      setLoading(true);
      getCategoryDetail(id)
        .then((response) => {
          setLoading(false);
          setData(response);
        })
        .catch((error) => {
          toast.error("Failed to fetch the category data!");
        });
    }
  }, [id]);

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    values,
    touched,
    errors,
  } = useFormik({
    initialValues: {
      name: data?.name || "",
      // convertToLabelValue(data?.parent_category)
      parentCaterory:
        data && data.parent_category
          ? {
              label: data.parent_category?.name,
              value: data.parent_category?.id,
            }
          : "",
    },
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      setIsSubmitting(true);
      const payload = {
        name: values.name,
        parent_id: values.parentCaterory.value,
      };
      if (id) {
        updateCategory(payload, id)
          .then((response) => {
            toast.success("Category Created successfully!");
          })

          .catch((error) => {
            toast.error(
              "Failed to Create Category" + error.response.data?.message
            );
          });
      } else {
        createCategory(payload)
          .then((response) => {
            toast.success("Category created successfully!");
            if (isModal) {
              onClose();
            } else {
              navigate("/inventory/categories");
            }
          })
          .catch((error) => {
            setIsSubmitting(false);
            toast.error(
              "Failed to create Category" + error.response.data?.message
            );
          });
      }
      setIsSubmitting(false);
      onClose();
    },
  });

  const fetchCategoryDetail = () => {
    getCategoryList()
      .then((response) => {
        setLoading(false);
        const newData = [{ name: "Parent Category", id: "" }, ...response.data];
        setCategorydata(convertToLabelValue(newData));
      })
      .catch((error) => {
        toast.error("Failed to fetch the staff data!");
      });
  };

  useEffect(() => {
    fetchCategoryDetail();
  }, []);

  return (
    <Fragment>
      {loading ? (
        <Loading />
      ) : (
        <div className={"flex flex-col w-full gap-4 bg-white rounded-md"}>
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div className={"flex flex-col gap-4 gap-y-2"}>
              <DefaultInput
                label={"Category Name"}
                name="name"
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.name && errors.name ? errors.name : ""}
                required
              />
              <DefaultSearchSelectInput
                label={"Parent - Category"}
                name="parentCaterory"
                options={categorydata}
                value={values.parentCaterory}
                // onChange={handleChange}
                onChange={(e) => {
                  setFieldValue("parentCaterory", e);
                }}
                onBlur={handleBlur}
                error={
                  touched.parentCaterory && errors.parentCaterory
                    ? errors.parentCaterory
                    : ""
                }
                required
              />
              <div className="col-span-2">
                <DragAndDropFile label={"Upload Document"} />
              </div>
            </div>
            <div className="flex items-center gap-2">
              <DefaultButton
                variant="default"
                name={id ? "Edit" : "Add"}
                type="submit"
                loading={isSubmitting}
              />
              {isModal ? (
                <DefaultButton
                  variant="secondary"
                  name={"Cancel"}
                  onClick={onClose}
                />
              ) : null}
            </div>
          </form>
        </div>
      )}
    </Fragment>
  );
};

export default ManageSalaryForm;
